<div class="generic-modal-root" >

    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
          <h3 style="text-align: center; font-weight: 300;">Choose the station you want to link to this operator to</h3>
          <table class="account-table">  
            <tr *ngFor="let station of availableStations">         
                <td class="account-name" >
                    <span>{{station.name}}</span>
                </td>
                <td style="padding: 15px; justify-content: center; display: flex;">
                    <chunky-check-box (click)="assignStation(station.stationId)" [checked]="operator?.stationId == station.stationId"></chunky-check-box>
                </td>
            </tr>            
        </table>
      </div>
    </div>
  
  
    <div style="height: 45px;">
      <button (click)="close()" class="btn btn-danger" style="margin-left: 15px;float: right;margin-top: 10px;">Cancel</button>
      <button (click)="saveAndClose()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Save</button>
    </div>
  </div> 